import axios from './CommonHttpRequest';
let baseUrl = `${process.env.REACT_APP_IDPROVIDER_API}`;

export const AuthenticateRecaptcha = async (data:any) => {
    return await axios.post(`${baseUrl}api/Authentication/AuthenticateReCaptcha`,data)
}